
import { MailIcon } from "vue-feather-icons";
import head from "../../mixins/MetaHead";
import redirectAuthenticatedUsersToDashboard from "../../mixins/redirectAuthenticatedUsersToDashboard";
import AzureUrlBuilder from "~/fc/utils/azure";

export default {
  name: "AuthLogin",
  components: {
    MailIcon,
  },
  mixins: [head, redirectAuthenticatedUsersToDashboard],
  layout: "blank",
  middleware: ['redirect-authenticated-users-to-dashboard'],
  asyncData({ from, store }) {
    if (from && !from.fullPath.includes("auth")) {
      store.commit("setRedirect", from.fullPath);
    }
  },
  data: () => ({
    title: "Login -  FreeConvert.com",
    desc: "Login to FreeConvert.com.",
    currentUrl: "/auth/signup",
  }),
  computed: {
    azureUrlBuilder() {
      return new AzureUrlBuilder(this.$i18n.locale);
    },
    loginUrl() {
      return this.azureUrlBuilder.LOGIN_FLOW_URL;
    },
    googleSignupSigninUrl() {
      return this.azureUrlBuilder.GOOGLE_SIGNUP_SIGNIN_FLOW_URL;
    },
    facebookSignupSigninUrl() {
      return this.azureUrlBuilder.FACEBOOK_SIGNUP_SIGNIN_FLOW_URL;
    },
  },
  mounted() {
    const redirectUrl = window.localStorage.getItem("redirect");

    // give priority to localStorage redirect URL if the internal app redirect URL is '/'
    if (this.$store.state.redirect === "/" && redirectUrl) {
      window.localStorage.setItem("redirect", redirectUrl);
      this.$store.commit("setRedirect", redirectUrl);
    } else {
      window.localStorage.setItem("redirect", this.$store.state.redirect);
    }

    this.$store.commit("updateBreadcrumbs", [
      {
        url: this.localePath("/auth/login"),
        label: this.$t("auth_login"),
      },
    ]);
  },
  methods: {
    setLocale() {
      $nuxt.$cookies.set("locale", this.$i18n.locale, {
        secure: false,
        expires: new Date(Date.now() + 86400 * 1000),
        path: "/",
      });
    }
  }
};
